import React from "react"
import Button from "@/common/components/_UI/Button"
import { ButtonsWrapper } from "@/common/Mixin"

interface ButtonsProps {
  btns: any[]
  type?: string
  className?: string
  center?: boolean
}

export default function Buttons({
  btns,
  type,
  className,
  center
}: ButtonsProps) {
  return (
    <ButtonsWrapper
      className={`${type ? type : ""} ${className ? className : ""} ${
        center ? "center" : ""
      }`}
    >
      {btns?.map(({ id, content, type, href, target, onClick }, index) => (
        <Button
          key={index}
          href={href}
          type={index === 1 ? "secondary" : type}
          target={target}
          onClick={onClick}
          content={content}
        />
      ))}
    </ButtonsWrapper>
  )
}
